module.exports = __webpack_public_path__ + "img/20220810085203.49ed1ef4.png";